import type AppStore from '@src/app/AppStore'

import CustomProtocolHandler, {
  PROTOCOL_QUO_WEB as PROTOCOL,
} from './CustomProtocolHandler'

export { PROTOCOL }

export default class WebQuoProtocolHandler extends CustomProtocolHandler {
  override readonly protocol = PROTOCOL
  override readonly web = true
  override readonly desktop = false

  constructor(app: AppStore) {
    super(app, PROTOCOL)
  }
}
